module.exports = __webpack_public_path__ + "img/ruffle_width.e5393a73.png";